export default __webpack_public_path__ + "static/media/JS.840d2db4.png";